/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Common utils for the app
 */
import CUATE_IMAGE from 'assets/onboarding/cuate.svg';
import VERITABLE_IMAGE from 'assets/onboarding/veritable.svg';
import DOCTOR_IMAGE from 'assets/onboarding/doctorImage.svg';
import UNLOCK_FEATURES from 'assets/onboarding/unlockFeatures.svg';
import APP_LOGO from 'assets/veritable-logo.svg';
import FALLBACK_IMAGE from 'assets/fallback-image.svg';

/**
 * getAppLogo
 */
const getAppLogo = (): string => APP_LOGO;

/**
 * getFallBackImage
 */
const getFallbackImage = (): string => FALLBACK_IMAGE;

// onboarding image
const eligibilityOnboardingImage = {
	getCuateImage: (): string => CUATE_IMAGE,
	getVeritableImage: (): string => VERITABLE_IMAGE,
	getDoctorImage: (): string => DOCTOR_IMAGE,
	getUnlockFeaturesImage: (): string => UNLOCK_FEATURES,
};

export { eligibilityOnboardingImage, getAppLogo, getFallbackImage };
